import * as PIXI from "pixi.js";
import { rootEventBus, EnumRootEventBus } from "../../../managers/RootEventBus";
import ProtractorRenderer from "./ProtractorRenderer";
import addInteractivity from "../../../utils/addInteractivity";
import { Coord } from "../../../types/Interface";
import getAngleBetweenPoints from "../../../utils/math/getAngleBtwPoints";
import { normalizeRadian } from "../../../utils/math/normalizeRadian";
import { CustomCursorType } from "../../UI/CustomCursor/CustomCursor";


export default class Protractor {
  private ProtractorRenderer = new ProtractorRenderer();
  private isGrabbing: boolean = false;
  private isRotating: boolean = false;
  private isRotatingLeft: boolean = false;
  private isMarkingAngle: boolean = false;
  private isMarkingLeft: boolean = false;
  private mStartCoord!: Coord;
  private grabDelta!: Coord;
  private mStartDeltaRad: number;

  constructor() {
    this.addInteractivities();

    rootEventBus.on(EnumRootEventBus.setPointerMove, (coord: Coord) => this.handlePointerMove(coord));
    rootEventBus.on(EnumRootEventBus.setPointerUp, () => this.handlePointerUp())
  }
  public setVisible = (v: boolean) => this.ProtractorRenderer.visible = v;
  addInteractivities() {
    addInteractivity(
      this.ProtractorRenderer.bg,
      { handleDownFunc: e => this.handleDownGrabButton(e) },
      CustomCursorType.grab
    );
    addInteractivity(
      this.ProtractorRenderer.rotateLButton,
      { handleDownFunc: e => this.handleDownRotateButton(e, true) },
      CustomCursorType.rotate
    );
    addInteractivity(
      this.ProtractorRenderer.rotateRButton,
      { handleDownFunc: e => this.handleDownRotateButton(e, false) },
      CustomCursorType.rotate
    );
    addInteractivity(
      this.ProtractorRenderer.markAngleLButton,
      { handleDownFunc: _ => this.handleDownMarkAngleButton(true) },
      CustomCursorType.grab
    )
    addInteractivity(
      this.ProtractorRenderer.markAngleRButton,
      { handleDownFunc: _ => this.handleDownMarkAngleButton(false) },
      CustomCursorType.grab
    )
  }
  private handlePointerMove(coord: Coord) {
    const center = { x: this.ProtractorRenderer.x, y: this.ProtractorRenderer.y };
    if (this.isGrabbing) {
      this.ProtractorRenderer.x = coord.x + this.grabDelta.x;
      this.ProtractorRenderer.y = coord.y + this.grabDelta.y;
    } else if (this.isRotating) {
      const rad = getAngleBetweenPoints(center, coord) + this.mStartDeltaRad;
      this.ProtractorRenderer.rotation = this.isRotatingLeft ? -Math.PI + rad : rad;
    } else if (this.isMarkingAngle) {
      const one = Math.PI / 180;
      const marker = this.isMarkingLeft ? this.ProtractorRenderer.markAngleLButton : this.ProtractorRenderer.markAngleRButton;
      const pRot = normalizeRadian(this.ProtractorRenderer.rotation);
      const rot = normalizeRadian(Math.floor((getAngleBetweenPoints(center, coord)) / one) * one);
      const max = normalizeRadian(pRot);
      const min = normalizeRadian(-(Math.PI + one) + pRot);

      if (rot <= max && rot >= min) {
        this.ProtractorRenderer.drawMarkAngleBtn(marker, rot - pRot, this.isMarkingLeft ? "yellow" : 0x00ff00);
      }
    }
  }
  private handlePointerUp() {
    this.isGrabbing = false;
    this.isRotating = false;
    this.isMarkingAngle = false;
    this.handleEventMode(true);
  }
  private handleDownGrabButton(e: PIXI.FederatedPointerEvent) {
    this.isGrabbing = true;
    this.mStartCoord = { x: e.global.x, y: e.global.y };
    this.grabDelta = {
      x: this.ProtractorRenderer.x - this.mStartCoord.x,
      y: this.ProtractorRenderer.y - this.mStartCoord.y
    }
    this.handleEventMode(false);
  }
  private handleDownRotateButton(e: PIXI.FederatedPointerEvent, isLeft: boolean) {
    const center = { x: this.ProtractorRenderer.x, y: this.ProtractorRenderer.y };

    this.isRotating = true;
    this.isRotatingLeft = isLeft;
    this.mStartCoord = { x: e.global.x, y: e.global.y };

    const _rad = getAngleBetweenPoints(center, this.mStartCoord);
    this.mStartDeltaRad = this.ProtractorRenderer.rotation - (isLeft ? Math.PI + _rad : _rad);
    this.handleEventMode(false);
  }
  private handleDownMarkAngleButton(isLeft: boolean) {
    this.isMarkingAngle = true;
    this.isMarkingLeft = isLeft;
  }
  private handleEventMode(v: boolean) {
    [this.ProtractorRenderer.bg, this.ProtractorRenderer.rotateLButton, this.ProtractorRenderer.rotateRButton]
      .forEach(elm => elm.eventMode = v ? 'static' : 'none');
  }
}